import footer from "./files/footer";
import home from "./files/home";
import news from "./files/news";

const settings = {
  name: "settings",
  label: "Settings",
  editor: {
    preview: false,
  },
  description: "Various Settings for the website",
  files: [home, footer, news],
};

export default settings;
